import { Request } from "./request/Request";

import {
  uniteUsersCSRF,
  updateMyRegCSRF,
  updateUserDataCat2,
} from "./toolkit/user/userActionsSlice";
import {
  attachSocnetCSRF,
  checkPassCorrectCSRF,
  checkSocnetCSRF,
  detachSocnetCSRF,
  loginCSRF,
  otpinLoginCSRF,
  requestActualizedUserSidCat2,
  socnetCSRF,
} from "./toolkit/user/authorizationSlice";
import {
  goToPreviousStep,
  resetState,
  setActiveStep,
  setActiveStepHard,
  setFallbackStep,
  setFormData,
  setRateLimitError,
} from "./toolkit/global/auth/authSlice";
import {
  checkEmailAvailabilityGUJ,
  recoverPasswordCSRF,
  confirmRecoverPasswordCSRF,
  registrationCSRF,
  verifyPhoneCSRF,
} from "./toolkit/user/registrationSlice";
import { setUserOffers } from "./toolkit/user/offersSlice";
import {
  removeHeader,
  setBrowserParams,
  setHeader,
} from "./toolkit/browser/browserSlice";

import {
  setAnalyticsData,
  setAuthPopupVisibility,
} from "./toolkit/global/headerAuth/headerAuthSlice";

import {
  changePasswordCSRF,
  changeProfilePrivacyCSRF,
  setMarketingConsentCSRF,
  setUserAccountSettings,
} from "./toolkit/user/accountSettingsSlice";
import {
  attachSocnetCat2,
  detachSocnetCat2,
  setUserSocnets,
} from "./toolkit/user/socnetSlice";
import {
  removeAvatar,
  setUserAvatar,
  uploadAvatarCSRF,
} from "./toolkit/user/avatarSlice";
import { setUserBalance } from "./toolkit/user/balanceSlice";
import { setUserBasket } from "./toolkit/user/basketSlice";
import { setUserBoughtCollection } from "./toolkit/user/boughtCollectionsSlice";
import {
  changeCredentialsCSRF,
  setUserCredentials,
} from "./toolkit/user/credentialsSlice";
import { setUserLibrary } from "./toolkit/user/librarySlice";
import {
  getUserNotifications,
  setUserNotifications,
} from "./toolkit/user/notificationsSlice";
import {
  cancelRequestBiblioArt,
  decrUserGifts_CSRF,
  getPresentBook_CSRF,
  getABTests,
  proceedPayment,
  readReport,
  requestBiblioArt,
  setCustomCookieValue,
  setFoundationUserABTests,
  setFoundationUserAccountSettings,
  setFoundationUserAvatar,
  setFoundationUserBalance,
  setFoundationUserLibrary,
  setFoundationUserLogin,
  setFoundationUserPartnersSubscriptions,
  setFoundationUserProfile,
  setFoundationUserSocnets,
  setFoundationUserSubscription,
  setFoundationUserSafemodeStep,
  setIsOfficeUser,
  setVarioqubTests,
  setUserID,
  setUserSID,
  teleport_CSRF,
  setFoundationUserAbonement,
} from "./toolkit/foundationUser/foundationUserSlice";
import {
  getPaymentReceipts,
  setPaymentReceipts,
} from "./toolkit/pages/recieptSlice";
import { setUserAbonement } from "./toolkit/user/abonementSlice";
import { setUserSubscription } from "./toolkit/user/subscriptionSlice";
import { setUserABTests } from "./toolkit/user/testsSlice";
import { setUserWebpushes } from "./toolkit/user/webpushesSlice";
import {
  clearSearchHistory,
  getSearchData,
  getSearchHistory,
  refreshSearchResults,
  saveSearchQuery,
  setSearchData,
  setSearchHistory,
} from "./toolkit/global/searchSlice";
import {
  setCurrentGenre,
  setHistory,
  setOpenPopup,
} from "./toolkit/global/genresSlice";
import {
  sendClickTrack,
  setForceScrollToReviewForm,
  setHeaderHeight,
  setHelpdeskConfig,
  setLoginPopupError,
  setPaymentPopup,
  setReviewComplainPopup,
  setSharingPopup,
  setSpamTicketsConfig,
  setStickyPlayer,
  setCheckoutBox,
  setIsPageWithPlayer,
} from "./toolkit/global/interfaceSlice";
import { setLastViewedWidgetData } from "./toolkit/global/lastViewedBooksWidgetSlice";
import {
  setAppCode,
  setCurrentStep,
  setEmail,
  setIsBiblioLogin,
  setIsLoading,
  setIsOldUser,
  setIsVerifyPhone,
  setLibrary,
  setLibraryStatus,
  setLoginFormat,
  setLoginReserved,
  setPassRecoveryMask,
  setPassRecoveryMethod,
  setPassRecoveryTimer,
  setPhone,
  setPhoneCode,
  setPrevSteps,
  setServerError,
  setStrategy,
  setUsersMerges,
  setUserStatus,
} from "./toolkit/global/loginSlice";
// TODO: Удалить после перехода на эндпоинт Foundation
import { getPhoneCodes as legacyGetPhoneCodes } from "./toolkit/global/phonecodesSlice";
import { subscribeToItemCSRF } from "./toolkit/global/subscriptionsToItemSlice";
import {
  setAudioSubscrBanner,
  setOnlyLitresBanner,
  setPromotionBanner,
  setSubscrBanner,
  setTvCampaignBanner,
} from "./toolkit/global/bannersSlice";
import {
  addLibrary,
  getUserLibrariesCSRF,
  teleportCSRF,
  uniteCSRF,
  uniteCSRFV2,
  unsubscribeCSRF,
} from "./toolkit/pages/personalCabinet/userLibrariesSlice";
import {
  paymentsHistoryCSRF,
  setHistoryData,
} from "./toolkit/pages/personalCabinet/paymentsHistorySlice";
import { getAvailableBonusesListGUJ } from "./toolkit/global/availableBonusesSlice";
import {
  changeLoyaltyCSRF,
  getLoyaltyCardsCSRF,
  setLoyaltyCards,
} from "./toolkit/pages/personalCabinet/loyaltyCardsSlice";
import {
  getBonusExpirationGUJ,
  setBonusesExpiration,
} from "./toolkit/pages/personalCabinet/bonusesSlice";
import {
  deletePaymentCardCSRF,
  getRebillsGUJ,
} from "./toolkit/user/rebillsSlice";
import {
  addArtReviewDislike,
  addArtReviewLike,
  removeArtReviewDislike,
  removeArtReviewLike,
} from "./toolkit/global/arts/reviews/artsReviewsSlice.likes";
import {
  addReviewComplain,
  updateReview,
} from "./toolkit/global/reviews/reviewsSlice";
import {
  addArtsReview,
  addReviewReply,
  getArtsReviews,
  getUserArtsReviews,
  setArtReviews,
  setArtReviewsMapId,
  setLastGetRequestDate,
} from "./toolkit/global/arts/reviews/artsReviewsSlice";
import { setArts, setUserRating } from "./toolkit/global/arts/artsSlice";
import { setUserPartnersSubscriptions } from "./toolkit/user/partnersSubscriptionsSlice";
import {
  getUserChannelsGUJ,
  getUserLangsGUJ,
  setUserChannels,
  setUserLangs,
  updateSpamCSRF,
} from "./toolkit/pages/personalCabinet/userSpamSlice";
import { setFaceHost, setFaceLang } from "./toolkit/global/faceSlice";

import {
  getZeroSearchRecommendation,
  getZeroSearchRecommendationsList,
} from "./toolkit/global/zeroSearchPageSlice";
import { takeBookCSRF } from "./toolkit/global/take/takeSlice";
import { setOpenOnboarding } from "./toolkit/global/onboardingSlice";

import {
  createCustomSet,
  createPodcastSet,
  createSeriesCustomSet,
  doOrder,
} from "./toolkit/payment/paymentSlice";

import {
  setContentsData,
  setContentsOpen,
  setCurrentTime,
  setDownloadForbidden,
  setMuted,
  setPlaybackRate,
  setPlayerData,
  setPlayerError,
  setPlayerEvent,
  setPlayerReady,
  setPlayerSettings,
  setPlaying,
  setReadOnly,
  setTimeStart,
  setUrl,
  setVolume,
  setPlayerStats,
  setTotalDuration,
} from "./toolkit/player/playerSlice";

import {
  getAudioNotes,
  lockAudioNotes,
  setArtId,
  setMyNotes,
  setOrder,
  updateAudioNotes,
} from "./toolkit/player/audioNotesSlice";

import { setGlobalModalsShowStatus } from "./toolkit/global/globalModals";

import { getBaseAPIUrl } from "./request/config/api";

const api = {
  user: {
    authorization: {
      requestActualizedUserSidCat2,
      checkPassCorrectCSRF,
      otpinLoginCSRF,
      loginCSRF,
      checkSocnetCSRF,
      attachSocnetCSRF,
      detachSocnetCSRF,
      socnetCSRF,
    },
    registration: {
      checkEmailAvailabilityGUJ,
      verifyPhoneCSRF,
      recoverPasswordCSRF,
      confirmRecoverPasswordCSRF,
      registrationCSRF,
    },
    credentials: {
      setUserCredentials,
      changeCredentialsCSRF,
    },
    balance: {
      setUserBalance,
    },
    accountSettings: {
      setUserAccountSettings,
      changePasswordCSRF,
      changeProfilePrivacyCSRF,
      setMarketingConsentCSRF,
    },
    socnet: {
      setUserSocnets,
      attachSocnetCat2,
      detachSocnetCat2,
    },
    library: {
      setUserLibrary,
    },
    webpushes: {
      setUserWebpushes,
    },
    tests: {
      setUserABTests,
    },
    notifications: {
      setUserNotifications,
      getUserNotifications,
    },
    basket: {
      setUserBasket,
    },
    boughtCollections: {
      setUserBoughtCollection,
    },
    abonement: {
      setUserAbonement,
    },
    subscription: {
      setUserSubscription,
    },
    partnersSubscriptions: {
      setUserPartnersSubscriptions,
    },
    avatar: {
      setUserAvatar,
      removeAvatar,
      uploadAvatarCSRF,
    },
    offers: {
      setUserOffers,
    },
    rebills: {
      getRebillsGUJ,
      deletePaymentCardCSRF,
    },
    actions: {
      updateUserDataCat2,
      updateMyRegCSRF,
      uniteUsersCSRF,
    },
  },
  foundationUser: {
    getABTests,
    setUserSID,
    setUserID,
    setFoundationUserLogin,
    setFoundationUserProfile,
    setFoundationUserBalance,
    setCustomCookieValue,
    setFoundationUserLibrary,
    setFoundationUserAccountSettings,
    setFoundationUserSocnets,
    setFoundationUserPartnersSubscriptions,
    setFoundationUserSubscription,
    setFoundationUserSafemodeStep,
    setFoundationUserAvatar,
    setFoundationUserABTests,
    setFoundationUserAbonement,
    setIsOfficeUser,
    setVarioqubTests,
    teleport_CSRF,
    getPresentBook_CSRF,
    decrUserGifts_CSRF,
    readReport,
    requestBiblioArt,
    cancelRequestBiblioArt,
    proceedPayment,
  },
  player: {
    data: {
      setPlayerData,
      setPlayerError,
      setPlayerEvent,
      setPlayerReady,
      setContentsOpen,
      setPlaying,
      setCurrentTime,
      setUrl,
      setVolume,
      setPlaybackRate,
      setMuted,
      setPlayerSettings,
      setDownloadForbidden,
      setReadOnly,
      setContentsData,
      setTimeStart,
      setPlayerStats,
      setTotalDuration,
    },
    notes: {
      updateAudioNotes,
      getAudioNotes,
      lockAudioNotes,
      setArtId,
      setMyNotes,
      setOrder,
    },
  },
  payment: {
    createCustomSet,
    createSeriesCustomSet,
    createPodcastSet,
    doOrder,
  },
  global: {
    modals: {
      setGlobalModalsShowStatus,
    },
    auth: {
      setActiveStep,
      setActiveStepHard,
      setFallbackStep,
      goToPreviousStep,
      setFormData,
      resetState,
      setRateLimitError,
    },
    header: {
      auth: {
        setAuthPopupVisibility,
        setAnalyticsData,
      },
      banners: {
        setSubscrBanner,
        setOnlyLitresBanner,
        setPromotionBanner,
        setAudioSubscrBanner,
        setTvCampaignBanner,
      },
    },
    availableBonuses: {
      getAvailableBonusesListGUJ,
    },
    search: {
      getSearchData,
      setSearchData,
      getSearchHistory,
      setSearchHistory,
      saveSearchQuery,
      clearSearchHistory,
      refreshSearchResults,
    },
    zeroSearch: {
      getZeroSearchRecommendationsList,
      getZeroSearchRecommendation,
    },
    lastViewedWidget: {
      setLastViewedWidgetData,
    },
    subscriptions: {
      subscribeToItemCSRF,
    },
    interfaceRequests: {
      setLoginPopupError,
      setStickyPlayer,
      setCheckoutBox,
      setHelpdeskConfig,
      setIsPageWithPlayer,
      setSpamTicketsConfig,
      setPaymentPopup,
      setReviewComplainPopup,
      setForceScrollToReviewForm,
      setSharingPopup,
      sendClickTrack,
      setHeaderHeight,
    },
    phoneCodes: {
      /**
       * @deprecated
       * NOTE: packages/modules/phone-input/src/hooks/useCountries.ts:98
       */
      getPhoneCodes: legacyGetPhoneCodes,
    },
    login: {
      setEmail,
      setStrategy,
      setUserStatus,
      setAppCode,
      setPhoneCode,
      setPhone,
      setCurrentStep,
      setLibraryStatus,
      setLibrary,
      setIsBiblioLogin,
      setIsLoading,
      setIsOldUser,
      setIsVerifyPhone,
      setLoginFormat,
      setPassRecoveryMethod,
      setPassRecoveryMask,
      setPassRecoveryTimer,
      setPrevSteps,
      setUsersMerges,
      setLoginReserved,
      setServerError,
    },
    genres: {
      setCurrentGenre,
      setHistory,
      setOpenPopup,
    },
    arts: {
      setArts,
      setUserRating,
      reviews: {
        setArtReviews,
        setArtReviewsMapId,
        getArtsReviews,
        addArtsReview,
        getUserArtsReviews,
        addArtReviewLike,
        removeArtReviewLike,
        addArtReviewDislike,
        removeArtReviewDislike,
        addReviewReply,
        setLastGetRequestDate,
      },
    },
    reviews: {
      updateReview,
      addReviewComplain,
    },
    take: {
      takeBookCSRF,
    },
    onboarding: {
      setOpenOnboarding,
    },
  },
  pages: {
    personalCabinet: {
      paymentsHistory: {
        paymentsHistoryCSRF,
        setHistoryData,
      },
      userLibraries: {
        teleportCSRF,
        unsubscribeCSRF,
        uniteCSRF,
        uniteCSRFV2,
        getUserLibrariesCSRF,
        addLibrary, // TODO: Непонятно для чего, не вызывает запросов
      },
      loyaltyCards: {
        getLoyaltyCardsCSRF,
        setLoyaltyCards,
        changeLoyaltyCSRF,
      },
      spam: {
        userLangs: {
          setUserLangs,
          getUserLangsGUJ,
        },
        userChannels: {
          setUserChannels,
          getUserChannelsGUJ,
        },
        updateSpamCSRF,
      },
      bonuses: {
        getBonusExpirationGUJ,
        setBonusesExpiration,
      },
    },
    paymentReceipts: {
      setPaymentReceipts,
      getPaymentReceipts,
    },
  },
  browser: {
    setBrowserParams,
    setHeader,
    removeHeader,
  },
  face: {
    setFaceLang,
    setFaceHost,
  },
};

export { Request, api, getBaseAPIUrl };
